import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const AlertTriangleIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg xmlns='http://www.w3.org/2000/svg' fill='currentColor' viewBox='0 0 24 24' {...props} ref={ref}>
        <path d='M11.9999 14C11.4476 14 10.9999 13.5523 10.9999 13V10C10.9999 9.44772 11.4476 9 11.9999 9C12.5522 9 12.9999 9.44772 12.9999 10V13C12.9999 13.5523 12.5522 14 11.9999 14Z'/>
        <path d='M10.4999 16.5C10.4999 15.6716 11.1715 15 11.9999 15C12.8284 15 13.4999 15.6716 13.4999 16.5C13.4999 17.3284 12.8284 18 11.9999 18C11.1715 18 10.4999 17.3284 10.4999 16.5Z'/>
        <path d='M10.2301 3.2156C10.9799 1.79093 13.0199 1.79092 13.7698 3.2156L22.1134 19.0685C22.8144 20.4003 21.8486 22 20.3436 22H3.65629C2.15127 22 1.18549 20.4003 1.88645 19.0685L10.2301 3.2156ZM20.3436 20L11.9999 4.1471L3.65629 20L20.3436 20Z'/>
    </svg>
));
